import React from 'react';
import classes from './MyCheckBox.module.scss';

function MyCheckBox() {
   return (
      <label className={classes.MyCheckBox}>
         <input type="checkbox" className={classes.MyCheckBoxCheck} id='application-checkbox' />
         <span className={classes.MyCheckBoxCheckFake}></span>
      </label>
   );
}
export default MyCheckBox;